class ServiceWorkerState {
}
export { ServiceWorkerState };
//# sourceMappingURL=ServiceWorkerState.js.map